import accountsContent from "./content/accounts.json";

export const accountsMock = {
  name: "accounts",
  layoutType: 1,
  areasList: [
    {
      id: "accounts-1",
      name: "accounts-content",
      componentName: "Comp:AccountsPage",
      content: JSON.stringify(accountsContent),
    },
  ],
};
